import Axios from "axios";

class ESocialEnvioDataService {
  getEventos(params) {
    return Axios.get("esocialEnvio/eventos", { params });
  }

  getEvento(id) {
    return Axios.get(`esocialEnvio/eventos/${id}`);
  }

  getXml(id) {
    return Axios.get(`esocialEnvio/eventos/${id}/xml`, {
      responseType: "text",
      transformResponse: (data) => data,
    });
  }

  getResumo() {
    return Axios.get("esocialEnvio/resumo");
  }

  getLotes(params) {
    return Axios.get("esocialEnvio/lotes", { params });
  }

  aprovar(id) {
    return Axios.post(`esocialEnvio/eventos/${id}/aprovar`);
  }

  revalidar(id) {
    return Axios.post(`esocialEnvio/eventos/${id}/revalidar`);
  }

  cancelar(id) {
    return Axios.post(`esocialEnvio/eventos/${id}/cancelar`);
  }

  reenviar(id) {
    return Axios.post(`esocialEnvio/eventos/${id}/reenviar`);
  }

  executar() {
    return Axios.post("esocialEnvio/executar");
  }

  // Tabelas do empregador (S-1000, S-1005 e S-1020).
  getTabelas() {
    return Axios.get("esocialTabelas");
  }

  salvarEmpregador(data) {
    return Axios.put("esocialTabelas/empregador", data);
  }

  salvarEstabelecimento(data) {
    return data.id
      ? Axios.put(`esocialTabelas/estabelecimentos/${data.id}`, data)
      : Axios.post("esocialTabelas/estabelecimentos", data);
  }

  excluirEstabelecimento(id) {
    return Axios.delete(`esocialTabelas/estabelecimentos/${id}`);
  }

  salvarLotacao(data) {
    return data.id
      ? Axios.put(`esocialTabelas/lotacoes/${data.id}`, data)
      : Axios.post("esocialTabelas/lotacoes", data);
  }

  excluirLotacao(id) {
    return Axios.delete(`esocialTabelas/lotacoes/${id}`);
  }

  importarTabelas() {
    return Axios.post("esocialTabelas/importar");
  }

  consultarTabelas() {
    return Axios.post("esocialTabelas/sincronizar");
  }

  getComplementoFuncionario(funcionarioId) {
    return Axios.get(`funcionarios/${funcionarioId}/esocial`);
  }

  salvarComplementoFuncionario(funcionarioId, data) {
    return Axios.put(`funcionarios/${funcionarioId}/esocial`, data);
  }
}

export default new ESocialEnvioDataService();
